import Immutable from 'immutable';

const Content: {
  name: string,
  paramName: string | null,
  setValue: ((key: string, value: any) => void) | null,
  extraData: any | null
} = {
  name: '',
  paramName: null,
  setValue: null,
  extraData: null
};

class NavigationView extends Immutable.Record(Content) {
}

export default NavigationView;
